import React, { useState } from 'react';
import cn from 'classnames';

import { useTranslation, useOnClickOutside, useAppDispatch, useGAEventCommonProps } from 'client/hooks';
import { analytics } from 'client/utils';
import { setIsShowShares } from 'client/redux/ui';
import TransitionComponent from '../TransitionComponent';
import Icon from '../Icon';
import SharesMenu from './SharesMenu';
import css from './SharesActions.module.scss';

interface Props {
  className?: string;
}

const SharesActions: React.FC<Props> = (props) => {
  const { className = '' } = props;
  const { translate } = useTranslation('actionsPanel');
  const [isActiveSharesMenu, setIsActiveSharesMenu] = useState<boolean>(false);
  const sharesWrapperRef = React.useRef<HTMLDivElement>(null);
  const { common } = useGAEventCommonProps();
  const dispatch = useAppDispatch();

  const clickOnBtn = () => {
    setIsActiveSharesMenu(!isActiveSharesMenu);
    if (isActiveSharesMenu) {
      dispatch(setIsShowShares(false));
    } else {
      analytics.gtag.event('audio_chat_content_click', {
        ...common,
        text_clicked: translate('btns.sharesBtn'),
      });
      dispatch(setIsShowShares(true));
    }
  };

  const closeMenu = () => {
    setIsActiveSharesMenu(false);
    dispatch(setIsShowShares(false));
  };

  useOnClickOutside<HTMLDivElement>(sharesWrapperRef, closeMenu);

  return (
    <div className={cn(css.sharesActionsWrapper, className)} data-testid="share-actions-wrapper" ref={sharesWrapperRef}>
      <div className={css.btn} data-testid="toggle-share-menu" onClick={clickOnBtn}>
        <div className={cn(css.iconWrapper)}>
          <Icon type="share" className={cn(css.icon, isActiveSharesMenu && css.active)} />
        </div>
        <div className={css.name}>{translate('btns.sharesBtn')}</div>
      </div>
      <TransitionComponent visible={isActiveSharesMenu} type="opacity">
        <SharesMenu closeMenu={closeMenu} />
      </TransitionComponent>
    </div>
  );
};

export default SharesActions;
